
export const MELCO_EMAIL_HISTORY_PRODUCT_CODES = 'ACCOUNT,MelcoOS,BravoOS,BerninaOS,DesignShop';
export const BERNINA_EMAIL_HISTORY_PRODUCT_CODES = 'TOOLBOX';

export type EmailHistoryProductCode =  string;
